import { convertUtcToLocalDate } from 'library/time';

export const formatUserProfile = (item = {}) => ({
  ...item,
  id: item.user_id,
  start_date: convertUtcToLocalDate(item.start_date),
  end_date: convertUtcToLocalDate(item.end_date)
});

export const formatUserTravelProfile = (item = {}) => ({
  ...item,
  id: item.user,
  passport_expiry: convertUtcToLocalDate(item.passport_expiry)
});

export const formatUserCompetency = (item = {}) => ({
  ...item,
  scheduled: convertUtcToLocalDate(item.scheduled),
  awarded_date: convertUtcToLocalDate(item.awarded_date),
  expiry_date: convertUtcToLocalDate(item.expiry_date)
});

export const formatUserCompetencyList = (list = []) => list.map(item => formatUserCompetency(item));
